type Init = (root: ParentNode) => void;
const initializers: Init[] = [];

/** Every kit module calls register() at import time; kit.ts runs them on load and after each htmx swap. */
export function register(init: Init): void {
  initializers.push(init);
}

export function run(root: ParentNode): void {
  for (const init of initializers) init(root);
}
